import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DataProcessingMergeStatusProps } from '../../../types/reduxTypes/dataProcessingMergeStatus';

const createReducer = <T extends SliceCaseReducers<DataProcessingMergeStatusProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingMergeStatusData(state, action) {
    state.dataProcessingMergeStatusData = action.payload;
  }
});

export default reducers;
